// 受付状態
export const ACCEPT_STATUS = {
  NOT_YET: 0, //未(受注時点)
  ACCEPTED: 1, //受付OK
  NOT_ACCEPTED: 2, //受付NG
};

// 注文状態
export const ORDER_STAUS_SHOP = {
  ACCEPTED: 0, //新規注文 --> blue
  COOKING: 1, //調理中
  WAITING: 2, //準備完了
  RECEIVED: 3, //受取済
  CANCEL: 4, //キャンセル --> red
  INVALID: 99, //無効値
};

// ユーザ注文状態
export const ORDER_STATUS_USER = {
  NORMAL: 0, //通常
  IN_CONFIRM: 1, //注文確認中
  WAITING: 2, //受取待ち
};

// 注文状態テキスト種類
export const ORDER_STATUS_TEXT_TYPE = {
  NOTHING: 0,
  IN_CONFIRM: 1,
  CANCELED: 2,
};

export const getOrderStatusTextType = (order) => {
  if (!Number.isInteger(order.acceptStatus)) {
    // 未定義(注文状態 対応前の過去注文データ) -> 表示なし
    return ORDER_STATUS_TEXT_TYPE.NOTHING;
  }

  const acceptStatus = Number(order.acceptStatus);
  if (acceptStatus == ACCEPT_STATUS.NOT_YET) {
    // 注文確認(未) -> 確認中
    return ORDER_STATUS_TEXT_TYPE.IN_CONFIRM;
  } else if (acceptStatus == ACCEPT_STATUS.NOT_ACCEPTED) {
    // 注文確認(NG) -> キャンセル
    return ORDER_STATUS_TEXT_TYPE.CANCELED;
  } else if (
    acceptStatus == ACCEPT_STATUS.ACCEPTED &&
    order.orderStatus == ORDER_STAUS_SHOP.CANCEL
  ) {
    // 注文確認(OK) かつ 注文キャンセル -> キャンセル
    return ORDER_STATUS_TEXT_TYPE.CANCELED;
  }
  // 注文確認(OK) -> 表示なし
  return ORDER_STATUS_TEXT_TYPE.NOTHING;
}

// 提供状態
export const PROVIDE_STATUS = {
  PROVIDED: 0, //提供可能
  SOLDOUT: 1, //本日完売
  RESALE_UNDECIDED: 2, //再販売未定
}
